import React, { FC, memo } from 'react';

import { AcceptanceAdvanceStatus } from '@shared/api/graphql/generated';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import Info, { InfoTypes } from '@zvuk-b2b/react-uikit/ui/Info';
import IconRenderer from '@zvuk-b2b/react-uikit/ui/icons/IconRenderer';

import { TEXTS } from './texts';
import icon from './sber_business_online_logo_small.svg';

import styles from './index.module.scss';

interface SberBusinessOnlineActionsProps {
  acceptanceAdvancedStatus: AcceptanceAdvanceStatus | null;
  startSigningAcceptanceAdvancedLoading: boolean;
  acceptanceAdvancedLoading: boolean;
  payerAccount: string;
  hasSberConnection: boolean;
  onStartSigningAcceptanceAdvanced: () => Promise<void>;
}

const SberBusinessOnlineActions: FC<SberBusinessOnlineActionsProps> = ({
  acceptanceAdvancedStatus,
  startSigningAcceptanceAdvancedLoading,
  acceptanceAdvancedLoading,
  payerAccount,
  hasSberConnection,
  onStartSigningAcceptanceAdvanced,
}) => {
  if (acceptanceAdvancedLoading) {
    return <div className={styles.skeleton} />;
  }

  const isWarningVisible =
    acceptanceAdvancedStatus !== AcceptanceAdvanceStatus.Active &&
    acceptanceAdvancedStatus !== AcceptanceAdvanceStatus.Authorized;

  const renderWarningBlock = () => {
    if (!hasSberConnection) {
      return (
        <Info
          type={InfoTypes.WARNING}
          className={styles.actionsInfo}>
          <span>{TEXTS.SBER_BUSINESS_ONLINE_NO_SBER_CONNECTION_TEXT}</span>
        </Info>
      );
    }

    return (
      <Info
        type={InfoTypes.WARNING}
        className={styles.actionsInfo}>
        <span>{TEXTS.SBER_BUSINESS_ONLINE_ACCEPTANCE_ADVANCED_WARNING_TEXT}</span>
      </Info>
    );
  };

  return (
    <div className={styles.actionsContainer}>
      {isWarningVisible ? (
        <>
          <Button
            elementId="button_sber_business_online_acceptance_advanced"
            className={styles.actionsPlainButton}
            type={ButtonType.PLAIN}
            isLoading={startSigningAcceptanceAdvancedLoading}
            isDisabled={startSigningAcceptanceAdvancedLoading || !hasSberConnection}
            onClick={onStartSigningAcceptanceAdvanced}>
            <IconRenderer
              iconHtml={icon}
              className={styles.actionsPlainButtonIcon}
            />
            {TEXTS.SBER_BUSINESS_ONLINE_ACCEPTANCE_ADVANCED_BUTTON_TEXT}
          </Button>
          {renderWarningBlock()}
        </>
      ) : (
        <Info
          type={InfoTypes.INFO}
          className={styles.actionsInfo}>
          {TEXTS.SBER_BUSINESS_ONLINE_ACCEPTANCE_ADVANCED_INFO_TEXT(payerAccount)}
        </Info>
      )}
    </div>
  );
};

export default memo(SberBusinessOnlineActions);
